<!-- 接口调用详情 -->
<template>
  <div>
    <div class="model-box">
      <div class="model-title">
        <span>基本信息</span>
      </div>
      <div class="model-content">
        <table class="public-table jbxx-table">
          <tr>
            <td class="td-head">公司名称</td>
            <td>{{userInfo.companyName}}</td>
            <td class="td-head">公司简介</td>
            <td>{{userInfo.brief}}</td>
            <td class="td-head">用户类型</td>
            <td>{{userInfo.brief}}</td>
          </tr>
          <tr>
            <td class="td-head">已使用总额（元）</td>
            <td>2000</td>
            <td class="td-head">本月使用额度（元）</td>
            <td>{{userInfo.residualAmount}}</td>
            <td class="td-head">当前剩余金额（元）</td>
            <td>{{userInfo.residualAmount}}</td>
          </tr>
          <tr>
            <td class="td-head">已使用上线数量</td>
            <td>新签</td>
            <td class="td-head">本月使用数量</td>
            <td>一年</td>
            <td class="td-head">已使用测试数量</td>
            <td>一年</td>
          </tr>
          <tr>
            <td class="td-head">开始日期</td>
            <td>{{userInfo.startTime}}</td>
            <td class="td-head">结束日期</td>
            <td>{{userInfo.endTime}}</td>
            <td class="td-head">剩余天数</td>
            <td>{{userInfo.endTime}}</td>
          </tr>
        </table>
      </div>
    </div>
    <div class="model-box">
      <div class="model-content">
        <el-tabs v-model="activePage" @tab-click="handleClick">
          <el-tab-pane  label="对账单" name="dzd">
            <el-table
              v-if="activePage=='dzd'"
              :data="dzdData"
              border
              style="width: 80%">
              <el-table-column
              label="期数"
              prop="qs"
              min-width="5%">
              </el-table-column>
              <el-table-column
              label="期间"
              prop="qj"
              min-width="25%">
              </el-table-column>
              <el-table-column
              label="接口种类"
              prop="jkzl"
              min-width="20%">
              </el-table-column>
              <el-table-column
              label="使用总次数"
              prop="syzcs"
              min-width="10%">
              </el-table-column>
              <el-table-column
              label="使用总额度（元）"
              prop="syzed"
              min-width="15%">
              </el-table-column>
              <el-table-column
              label="剩余额度（元）"
              prop="syed"
              min-width="15%">
              </el-table-column>
              <el-table-column
                label="详情"
                min-width="10%">
                <template slot-scope="scope">
                  <a @click="detailsFun(scope.row.userId)">查看</a>
                  <a @click="downLoadFun(scope.row.userId)">下载</a>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
          <el-tab-pane  label="上线使用情况" name="sxsyqk">
            <template v-if="activePage=='sxsyqk'">
              <el-tabs v-model="sxActiveName" @tab-click="handleClick">
                <el-tab-pane v-for="(item,index) in ApiList" :key="index" :label="item.interDesc" :name="item.interId">
                  <el-table
                    v-if="sxActiveName==item.interId"
                    ref="multipleTable"
                    :data="item.items"
                    border
                    style="width: 80%">
                    <el-table-column
                      prop="interDesc"
                      label="接口名称"
                      min-width="40%">
                    </el-table-column>
                    <el-table-column
                      prop="interDesc"
                      label="接口单价（元）"
                      min-width="40%">
                    </el-table-column>
                    <el-table-column
                      prop="interDesc"
                      label="使用次数"
                      min-width="40%">
                    </el-table-column>
                    <el-table-column
                      prop="interDesc"
                      label="小计（元）"
                      min-width="40%">
                    </el-table-column>
                  </el-table>
                </el-tab-pane>
              </el-tabs>
            </template>
          </el-tab-pane>
          <el-tab-pane  label="测试使用情况" name="cssyqk">
            <template v-if="activePage=='cssyqk'">
              <el-tabs v-model="csActiveName" @tab-click="handleClick">
                <el-tab-pane v-for="(item,index) in ApiList" :key="index" :label="item.interDesc" :name="item.interId">
                  <el-table
                    v-if="csActiveName==item.interId"
                    ref="multipleTable"
                    :data="item.items"
                    border
                    style="width: 80%">
                    <el-table-column
                      prop="interDesc"
                      label="接口名称"
                      min-width="40%">
                    </el-table-column>
                    <el-table-column
                      prop="interDesc"
                      label="配置次数"
                      min-width="40%">
                    </el-table-column>
                    <el-table-column
                      prop="interDesc"
                      label="使用次数"
                      min-width="40%">
                    </el-table-column>
                    <el-table-column
                      prop="interDesc"
                      label="剩余次数"
                      min-width="40%">
                    </el-table-column>
                  </el-table>
                </el-tab-pane>
              </el-tabs>
            </template>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <el-dialog
      title="对账单明细"
      :visible.sync="dialogVisible"
      width="800px"
      :close-on-click-modal='false'>
      <div class="dialog-content">
        <div class="title">第4期对账单（2019-07-07 - 2019-08-06 ）</div>
        <el-table
          :data="detailInfo.qsInfo"
          border
          style="width: 100%">
          <el-table-column
            prop="qs"
            label="期数"
            min-width="10%">
          </el-table-column>
          <el-table-column
            prop="qj"
            label="期间"
            min-width="30%">
          </el-table-column>
          <el-table-column
            prop="jkzl"
            label="接口种类"
            min-width="20%">
          </el-table-column>
          <el-table-column
            prop="syzcs"
            label="使用总次数"
            min-width="20%">
          </el-table-column>
          <el-table-column
            prop="syzed"
            label="使用总额度（元）"
            min-width="20%">
          </el-table-column>
        </el-table>
        <p class="title2">接口使用详情</p>
        <el-table
          :data="detailInfo.apiInfo"
          border
          style="width: 100%">
          <el-table-column
            prop="qs"
            label="接口名称"
            min-width="40%">
          </el-table-column>
          <el-table-column
            prop="qj"
            label="接口单价（元）"
            min-width="20%">
          </el-table-column>
          <el-table-column
            prop="jkzl"
            label="使用次数"
            min-width="20%">
          </el-table-column>
          <el-table-column
            prop="syzcs"
            label="小计（元）"
            min-width="20%">
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">关 闭</el-button>
        <el-button type="primary">下 载</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'UserAddOrEditUser',
  data () {
    return {
      type:this.$route.query.type,
      userInfo:{
        id:this.$route.query.id || '',
        companyName:'北京道口金科科技有限公司',
        brief:'道口金科',
        rechargeType:'',
        rechargeAmount:0,
        residualAmount:30,
        termOfUse:'',
        startTime:'',
        endTime:''
      },
      activePage: 'dzd',
      dzdData:[{
        qs:1,
        qj:'2019-07-07 - 2019-08-06',
        jkzl:'工商数据',
        syzcs:'100',
        syzed:'200',
        syed:'500'
      }],
      sxsyqkData:[],
      cssyqkData:[],
      ApiList:[],
      sxActiveName: '',
      csActiveName:'',
      dialogVisible:false,
      detailInfo:{
        qsInfo:[{
          qs:'4',
          qj:'2019-07-07 - 2019-08-06',
          jkzl:'工商数据',
          syzcs:'100',
          syzed:'200',
        }],
        apiInfo:[]
      }
    }
  },
  mounted () {
    var _this=this;
    _this.selectAPIFun();
  },
  methods:{
    handleClick(tab, event) {
      var _this=this;
      _this.$nextTick(() => {

      });
    },
    // 获取所有接口列表
    selectAPIFun:function(userId){
      var _this=this;
      _this.selectUserId=userId;
      _this.$axios.post('/requestApi/manage/find/allInterface?userId=2')     
        .then(function(response){
          let data = response.data;
          if(data.meta.retCode==0){
            _this.ApiList=[];
            data.data.forEach(function(item){
              var itemObj=new Object();
              itemObj.interId=item.interId;
              itemObj.interDesc=item.interDesc;
              itemObj.items=[];
              item.items.forEach(function(itemChild){
                if(itemChild.interUrl!=null){
                  itemObj.items.push(itemChild)
                };
              });
              _this.ApiList.push(itemObj);
            });

            _this.ApiList.forEach(function(item){
              item.items.forEach(function(itemChild){
                // if(itemChild.interfaceTotal==null){
                //   itemChild.interfaceTotal=0;
                // };
                if(itemChild.interUnitPrice==null){
                  itemChild.interUnitPrice=0;
                };
                if(itemChild.interfaceTestTotal==null){
                  itemChild.interfaceTestTotal=0;
                };
              });
            });
            _this.sxActiveName=_this.ApiList[0].interId;
            _this.csActiveName=_this.ApiList[0].interId;
          }else{
            console.log(data.meta.friendlyMsg);
          }
        })
        .catch(function(error){
          console.log(error)
        });
    },
    //详情
    detailsFun:function(){
      var _this=this;
      _this.dialogVisible=true;
    },
    //下载
    downLoadFun:function(id){

    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.jbxx-table tr td{width: 35%;}
.jbxx-table tr .td-head{width: 15%;}
.select-box-btn{margin: 0 auto;}
.public-table tr td{width: 23.3333%;}
.public-table tr .td-head{width: 10%;}
.title{font-size: 22px;margin-bottom: 20px;text-align: center; color: #333;}
.title2{font-size: 16px;display: block;border-left: 2px solid #333;text-indent: 6px;margin-bottom: 10px;margin-top: 20px;}

</style>



// WEBPACK FOOTER //
// src/components/InterfaceCallDetail.vue